import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'
// import VueRouter from 'vue-router'

import httpClient from './plugins/httpClient';
import errorHandler from "./plugins/errorHandler";

import DiiaLoaderOverlay from './components/custom/DiiaLoaderOverlay.vue';
import DiiaAlertNotification from './components/custom/DiiaAlertNotification.vue';
import DiiaAlertNotificationMultiple from './components/custom/DiiaAlertNotificationMultiple.vue';
import DiiaMessageBox from './components/custom/DiiaMessageBox.vue';

// Vue.use(VueRouter)

Vue.use(httpClient);
Vue.use(errorHandler);


Vue.prototype.$config = require('./config').default;  // Load envs


var createHost = require('cross-domain-storage/host');

var storageHost = createHost([
  {
      origin: 'https://catalog-web-dev.trembita.gov.ua',
      allowedMethods: ['get'],
  },
  {
    origin: 'https://catalog-stage.trembita.gov.ua',
    allowedMethods: ['get'],
},
{
  origin: 'https://catalog.trembita.gov.ua',
  allowedMethods: ['get'],
},
]);


Vue.prototype.$clib = require('./js/common_lib').default;

Vue.component('DiiaLoaderOverlay', DiiaLoaderOverlay);
Vue.component('DiiaAlertNotification', DiiaAlertNotification);
Vue.component('DiiaAlertNotificationMultiple', DiiaAlertNotificationMultiple);
Vue.component('DiiaMessageBox', DiiaMessageBox);

Vue.config.productionTip = false

// App.component('DiiaLoaderOverlay', DiiaLoaderOverlay);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')